import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TagsRight } from '@pages/Updates/components/UpdatesNew/Updates.styles';
import { beam } from '@styles/colors/themes';
import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 12px 16px 24px 16px;
  width: 100%;
  height: 100%;
  max-width: 900px;
  max-height: 700px;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
`;

export const Close = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 5px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Back = styled.img`
  cursor: pointer;
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Line = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
`;

interface IConfirm {
  disabled?: boolean;
}

export const Confirm = styled.button<IConfirm>`
  display: flex;
  height: 36px;
  padding: 0 16px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #d8dae5;
  align-items: center;
  color: #1371fe;
  font-size: 14px;
  font-weight: 500;
`;

export const Row = styled.div<ITagsRight>`
  display: flex;
  align-items: center;
  flex-direction: row;

  &.header {
    margin-bottom: 24px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IInput {
  isError?: boolean;
  isLink?: boolean;
}

export const Input = styled.input<IInput>`
  display: flex;
  width: 331px;
  height: 36px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  font-size: 12px;

  color: ${({ isLink }) => (isLink ? beam.color.primaryBlue : '#474d66')};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};

  transition: all 0.2s;

  margin-top: 8px;

  ::placeholder {
    color: #8f95b2;
  }
  &.infoInputs {
    width: 100%;
  }
`;
export const SelectFile = styled.label`
  display: flex;
  width: 90px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

export const FileName = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: #474d66;
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
`;

export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

export const ProfileImg = styled.img`
  width: 62px;
  height: 62px;
  border-radius: 32px;

  margin-right: 24px;
  object-fit: cover;
`;

export const Form = styled.form`
  width: 100%;
`;

export const Divider = styled.div`
  height: 24px;
`;

export const SpacingDivider = styled.div`
  width: 16px;
`;

export const Description = styled.div`
  font-weight: 400;
  color: #474d66;
  font-size: 14px;
  margin-bottom: 24px;
`;

export const Error = styled.div`
  color: #ea1212;
  font-size: 12px;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const InvIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 9px;
`;

export const Table = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 2fr 1fr 1fr 2fr;
  column-gap: 24px;
`;

export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Head = styled.div`
  background: #fff;
  padding-top: 7px;
  padding-bottom: 7px;
  color: #8f95b2;
  font-size: 12px;
  font-weight: 400;

  &.member {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    padding-left: 7px;
  }

  &.center {
    padding-left: 7px;
  }

  &.menu {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  border-radius: 15px;
  padding: 4px 12px 4px 12px;
  font-size: 14px;
  font-weight: 500;
  background: #edeff4;
  color: #474d66;
  margin-right: 8px;
`;

export const AssetImg = styled.div`
  display: flex;
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #e6e8f0;
  align-items: center;
  justify-content: center;

  margin-right: 10px;
`;

export const Item = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 2fr 1fr 1fr 2fr;
  padding: 8px 0px 8px 0;
  column-gap: 24px;
  align-items: center;
  column-gap: 20px;
  cursor: pointer;
  border-radius: 8px;

  --parent-bg: #fff;
  :hover {
    background-color: #f5f7fb;
  }
  :hover ${TagsRight} {
    background: linear-gradient(90deg, rgba(0, 0, 0, 0) 74%, #f5f7fb 97%);
  }
`;

export const AssetName = styled.div`
  color: #1b203a;
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Items = styled.div`
  overflow: auto;
  overflow-y: auto;
  height: 576px;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
    position: fixed;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
interface ITagsRight {
  hover?: boolean;
}

// interface ITagContainer {
//   background?: string;
//   color?: string;
// }

// export const TagContainer = styled.div<ITagContainer>`
//   height: 30px;
//   border-radius: 15px;
//   padding: 0 12px;
//   background: ${({ background }) => background || '#edeff4'};
//   color: ${({ color }) => color || '#474d66'};
//   font-size: 14px;
//   font-weight: 500;
//   display: flex;
//   align-items: center;
//   width: fit-content;
//   white-space: nowrap;

//   & + & {
//     margin-left: 8px;
//   }
// `;

export const Empty = styled.div`
  color: #8f95b2;
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
`;
